export default {
  isLoggedIn(state) {
    return state.auth.user !== null
  },
  user(state) {
    return state.auth.user
  },
}
